import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialogList: Array<any> = [];

  constructor() { }

  add(dialog: any) {
    // add a dialog element to a list for tracking
    this.dialogList.push(dialog);
  }

  remove(id: string) {
    this.dialogList = this.dialogList.filter(dialog => dialog.id !== id);
  }

  open(id: string): Promise<any> {
    return new Promise((resolve) => {
      const dialog = this.dialogList.find(dialog => dialog.id === id);
      dialog.open().then(response => resolve(response));
    });
  }

  close(id: string) {
    const dialog = this.dialogList.find(dialog => dialog.id === id);
    dialog.close()
  }
}
